import { mutatorAction } from 'satcheljs';
import { connectedAccountsStore } from '../../store/store';
export var toggleConnectGmailWindow = mutatorAction('toggleConnectGmailWindow', function (state) {
    var store = connectedAccountsStore();
    store.dialogWindowState.connectGmailOpen = state.connectGmailOpen;
});
//# sourceMappingURL=toggleConnectGmailWindow.js.map